import React, { useEffect, useState } from "react";
import { Link, useMatch } from "react-router-dom";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import {
  getFranchiseDetails,
  getAllSchoolDetailsForFranchise,
  getInstituteDeatilsForId,
  getAllSchoolDetailsForInstitute,
} from "../../store/actions";
import error from "../../assets/images/error-img.png";

const FranchiseEnquiry = (props) => {
  const [franchiseName, franchiseNameOps] = useState("");
  const [franchiseLogoUrl, franchiseLogoUrlOps] = useState("");
  const [allSchoolList, allSchoolListOps] = useState([]);
  const [allStateList, allStateListOps] = useState([]);
  const [allCityList, allCityListOps] = useState([]);
  const [filterAllSchoolList, filterAllSchoolListOps] = useState([]);
  const [selectedState, selectedStateOps] = useState("");
  const [selectedCity, selectedCityOps] = useState("");
  const [selectedSchoolId, selectedSchoolIdOps] = useState("");
  const [showInvalidUrl, showInvalidUrlOps] = useState(false);
  const [loadSuccess, loadSuccessOps] = useState(false);
  const [redirectTo, redirectToOps] = useState("");
  const [id, idOps] = useState("");
  const stateName = {
    KA: "Karnataka",
    AP: "Andhra Pradesh",
    TG: "Telangana",
    TS: "Telangana",
    UP: "Uttar Pradesh",
    PB: "Punjab",
    GJ: "Gujarat",
    HR: "Haryana",
    OD: "Odisha",
    MP: "Madhya Pradesh",
    MH: "Maharashtra",
    RJ: "Rajasthan",
    GA: "Goa",
    JK: "Jammu and Kashmir",
    CG: "Chandigarh",
    TN: "Tamil Nadu",
    PY: "Puducherry",
    AR: "Arunachal Pradesh",
    AS: "Assam",
    BR: "Bihar",
    HP: "Himachal Pradesh",
    JH: "Jharkhand",
    KL: "Kerala",
    MN: "Manipur",
    ML: "Meghalaya",
    MZ: "Mizoram",
    NL: "Nagaland",
    SK: "Sikkim",
    TR: "Tripura",
    UK: "Uttarakhanad",
    UA: "Uttarakhanad",
    WB: "West Bengal",
    DL: "Delhi",
    PY: "Puducherry",
    LD: "Lakshadweep",
    LA: "Ladakh",
    DD: "Daman and Diu",
    DN: "Dadra and nagar Haveli",
    CH: "Chandigarh",
    AN: "Andaman and Nicobar Islands",
  };
  const franchiseEnq = useMatch("/franchise/enquiry/:id");
  const instituteEnq = useMatch("/institute/enquiry/:id");
  let franchiseId = franchiseEnq && franchiseEnq.params.id;
  let instituteId = instituteEnq && instituteEnq.params.id;
  useEffect(() => {
    if (franchiseId) {
      redirectToOps("franchise-enquiry-form");
      idOps(franchiseId);
      props.getFranchiseDetails(franchiseId);
      props.getAllSchoolDetailsForFranchise(franchiseId);
    } else if (instituteId) {
      redirectToOps("institute-enquiry-form");
      idOps(instituteId);
      props.getInstituteDeatilsForId(instituteId);
      props.getAllSchoolDetailsForInstitute(instituteId);
    }
  }, [franchiseId, props.loadSuccess, instituteId]);
  useEffect(() => {
    if (props.franchise) {
      loadSuccessOps(true);
      franchiseNameOps(props.franchise.attributes.name);
      if (props.franchise.attributes.logo) {
        franchiseLogoUrlOps(props.franchise.attributes.logo._url);
      }
    } else if (props.institute) {
      loadSuccessOps(true);
      franchiseNameOps(props.institute.attributes.name);
      if (props.institute.attributes.logo) {
        franchiseLogoUrlOps(props.institute.attributes.logo._url);
      }
    } else {
      if (props.loadSuccess) {
        showInvalidUrlOps(true);
      }
    }
  }, [props.franchise, props.loadSuccess, props.institute]);
  useEffect(() => {
    if (props.schools.length > 0) {
      allSchoolListOps(props.schools);
      let stateList = [];
      for (const val of props.schools) {
        if (val.attributes.areaCode) {
          if (!stateList.includes(val.attributes.areaCode.trim())) {
            stateList.push(val.attributes.areaCode.trim());
          }
        }
      }
      allStateListOps(stateList);
      selectedStateOps(stateList[0]);
    }
  }, [props.schools]);
  useEffect(() => {
    if (selectedState) {
      let cityList = [];
      for (const val of allSchoolList) {
        if (
          val.attributes.areaCode === selectedState &&
          val.attributes.city &&
          !cityList.includes(val.attributes.city.trim())
        ) {
          cityList.push(val.attributes.city.trim());
        }
      }
      allCityListOps(cityList);
      selectedCityOps(cityList[0]);
    }
  }, [selectedState]);
  useEffect(() => {
    if (selectedCity) {
      let orderSchoolList = [];
      for (const val of allSchoolList) {
        if (
          val.attributes.areaCode === selectedState &&
          val.attributes.city.trim() === selectedCity
        ) {
          let temp = {};
          temp.id = val.id;
          temp.name = val.attributes.Name;
          orderSchoolList.push(temp);
        }
      }
      filterAllSchoolListOps(orderSchoolList);
      selectedSchoolIdOps(orderSchoolList[0].id);
    }
  }, [selectedCity]);
  return (
    <React.Fragment>
      <Container fluid={true} className="page-content">
        <Row>
          {showInvalidUrl && (
            <Container>
              <Row>
                <Col lg="12">
                  <div className="text-center mb-5">
                    <h1 className="display-2 font-weight-medium">
                      4
                      <i className="bx bx-buoy bx-spin text-primary display-3"></i>
                      4
                    </h1>
                    <h4 className="text-uppercase">Sorry, page not found</h4>
                    {/* <div className="mt-5 text-center">
                      <Link
                        className="btn btn-primary waves-effect waves-light"
                        to="/dashboard"
                      >
                        Back to Dashboard
                      </Link>
                    </div> */}
                  </div>
                </Col>
              </Row>
              <Row className="justify-content-center">
                <Col md="8" xl="6">
                  <div>
                    <img src={error} alt="" className="img-fluid" />
                  </div>
                </Col>
              </Row>
            </Container>
          )}
          {!showInvalidUrl && loadSuccess && (
            <Col className="mx-auto" lg={8}>
              <div className="text-center mt-3">
                {franchiseLogoUrl && (
                  <img
                    src={franchiseLogoUrl}
                    width="100"
                    alt=""
                    className="img-thumbnail rounded-circle"
                  />
                )}
                <h3>Welcome to {franchiseName}</h3>
                <p className="mt-2">Select Your Nearest Center</p>
              </div>
              <Card>
                <CardBody>
                  <AvForm
                    className="outer-repeater"
                    style={{ border: "1px" }}
                    // onSubmit={isFormValid}
                  >
                    <div
                      data-repeater-list="outer-group"
                      className="outer mt-2"
                    >
                      <div data-repeater-item className="outer">
                        <p className="mt-2 mb-0">State</p>
                        <select
                          className="custom-select"
                          value={selectedState}
                          onChange={(e) => {
                            selectedStateOps(e.target.value);
                          }}
                        >
                          {allStateList.map((val, key) => (
                            <option key={key} value={val}>
                              {stateName[val]}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div data-repeater-item className="outer mt-2">
                        <p className="mt-2 mb-0">City</p>
                        <select
                          className="custom-select"
                          value={selectedCity}
                          onChange={(e) => {
                            selectedCityOps(e.target.value);
                          }}
                        >
                          {allCityList.map((val, key) => (
                            <option value={val} key={key}>
                              {val}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div data-repeater-item className="outer mt-2">
                        <p className="mt-2 mb-0">Branches</p>
                        <select
                          className="custom-select"
                          value={selectedSchoolId}
                          onChange={(e) => {
                            selectedSchoolIdOps(e.target.value);
                          }}
                        >
                          {filterAllSchoolList.map((val, key) => (
                            <option value={val.id} key={key}>
                              {val.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div
                        data-repeater-item
                        className="outer mt-2 text-center"
                      >
                        <Link
                          to={`/${redirectTo}/${selectedSchoolId}/${id}`}
                          className="btn btn-primary"
                          style={{ width: "40%" }}
                        >
                          {props.t("Next")}
                        </Link>
                      </div>
                    </div>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          )}
        </Row>
      </Container>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {
  const { franchise, schools, loadSuccess, institute } = state.School;
  return { franchise, schools, loadSuccess, institute };
};
export default withNamespaces()(
  connect(mapStatetoProps, {
    getFranchiseDetails,
    getAllSchoolDetailsForFranchise,
    getInstituteDeatilsForId,
    getAllSchoolDetailsForInstitute,
  })(FranchiseEnquiry)
);
